<template>
    <el-radio-group v-model="radio" :disabled="disabled" @input="handleChange">
        <el-radio v-for="item in rOptions" :label="item.label" :key="item.label">{{ item.text }}</el-radio>
    </el-radio-group>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
export default {
    props: {
        value: {
            type: String || Number,
            default () {
                return '';
            }
        },
        dictCode: {
            type: String,
            default () {
                return '';
            }
        },
        options: {
            type: Array,
            default () {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default () {
                return false;
            }
        }
    },
    data() {
        return {
            radio: [],
            rOptions: []
        };
    },
    methods: {
        handleChange(val) {
            this.$emit('change', val);
        },
        setOptions(dictData) {
            this.rOptions = []
            for (const key in dictData) {
                if (dictData[key]) {
                    this.rOptions.push({
                        label: key,
                        text: dictData[key]
                    });
                }
            }
        }
    },
    mounted() {
        if (this.dictCode) {
            dictWithUrl(this.dictCode).then(res => {
                if (res && +res.code === 0) {
                    this.setOptions(res.data[this.dictCode]);
                }
            });
        } else {
            this.rOptions = this.options;
        }
    },
    watch: {
        value: {
            handler(val) {
                this.radio = val;
            },
            immediate: true
        }
    }
};
</script>
